import React, { useEffect, useState } from 'react';
import MainPage from './pages/MainPage';
import StatusPage from './pages/StatusPage';
import GameOfLifeBackground from './components/GameOfLifeBackground';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState<'main' | 'status'>('main');
  const [statusCode, setStatusCode] = useState<number>(404);

  // Route handling based on URL
  useEffect(() => {
    const path = window.location.pathname || '/';
    const normalized = path.toLowerCase();

    const statusMatch = normalized.match(/^\/status\/(\d{1,3})$/);
    if (statusMatch) {
      setStatusCode(parseInt(statusMatch[1], 10));
      setCurrentPage('status');
      return;
    }

    if (normalized === '/' || normalized === '/index.html' || normalized === '') {
      setCurrentPage('main');
      return;
    }

    // Unknown path -> redirect to status page
    window.location.href = '/status/404';
  }, []);

  return (
    <div className="app-root">
      <GameOfLifeBackground statusCode={currentPage === 'status' ? statusCode : undefined} />
      <main className="app-content" aria-live="polite">
        {currentPage === 'main' ? <MainPage /> : <StatusPage statusCode={statusCode} />}
      </main>
    </div>
  );
}

export default App;
